import { render } from "./FootComp.vue?vue&type=template&id=0ad89e24&scoped=true"
import script from "./FootComp.vue?vue&type=script&lang=js"
export * from "./FootComp.vue?vue&type=script&lang=js"

import "./FootComp.vue?vue&type=style&index=0&id=0ad89e24&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad89e24"]])

export default __exports__